"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("./api");
function wrapJSX(jsx) {
    return function (type, props, ...rest) {
        if (type === "react-native-css-interop-jsx-pragma-check") {
            return true;
        }
        if (process.env.NODE_ENV !== "test")
            require("./components");
        if (props && props.cssInterop === false) {
            delete props.cssInterop;
        }
        else {
            type = api_1.interopComponents.get(type) ?? type;
        }
        return jsx.call(jsx, type, props, ...rest);
    };
}
exports.default = wrapJSX;
//# sourceMappingURL=wrap-jsx.js.map